import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import Breadcrumbs from './components/bread_crumbs'
import { store } from './store';
import VueFeather from 'vue-feather';
import firebase from 'firebase/app';
import Vuelidate from 'vuelidate';
import Toasted from 'vue-toasted';
import axios from "axios";
import VueAxios from "vue-axios";
import VueMoment from 'vue-moment';
import VueSweetalert2 from 'vue-sweetalert2';
import VCalendar from "v-calendar";


// Import Theme scss
import './assets/scss/app.scss'

// config for firebase
import config from './config.json'

Vue.use(VueFeather);
Vue.use(BootstrapVue);
Vue.component('Breadcrumbs', Breadcrumbs);
Vue.use(Vuelidate);
Vue.config.productionTip = false;
firebase.initializeApp(config.firebase);
Vue.use(VueMoment);
Vue.use(VueSweetalert2);
Vue.use(VCalendar);

const http = axios.create({
  baseURL: process.env.VUE_APP_URL
});

Vue.use(VueAxios, http, axios);

Vue.use(Toasted,{
  iconPack: 'fontawesome'
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
